import React from 'react';
import { Bot } from 'lucide-react';

type GenerationStage = 'analyzing' | 'building' | 'finalizing';

interface CarouselGenerationLoadingProps {
  open: boolean;
  progress: number;
  stage: GenerationStage;
}

const STAGE_LABELS: Record<GenerationStage, string> = {
  analyzing: 'Analisando Conteúdo',
  building: 'Construindo Estrutura Viral',
  finalizing: 'Finalizando',
};

const CarouselGenerationLoading: React.FC<CarouselGenerationLoadingProps> = ({
  open,
  progress,
  stage,
}) => {
  if (!open) return null;

  const clampedProgress = Math.max(0, Math.min(100, progress));

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm px-4">
      <div className="w-full max-w-xl rounded-3xl border border-border bg-card/95 shadow-2xl p-8">
        <div className="flex justify-center mb-5">
          <div className="relative h-20 w-20 rounded-full border border-primary/30 bg-background flex items-center justify-center">
            <Bot className="h-8 w-8 text-primary" />
            <span className="absolute -right-1 -top-1 h-3 w-3 rounded-full bg-blue-400 animate-pulse" />
            <span className="absolute -left-2 bottom-3 h-2 w-2 rounded-full bg-primary/80 animate-pulse" />
          </div>
        </div>

        <div className="text-center space-y-1 mb-6">
          <h3 className="text-3xl font-semibold tracking-tight">Gerando seu carrossel...</h3>
          <p className="text-muted-foreground">{STAGE_LABELS[stage]}</p>
        </div>

        <div className="space-y-3">
          <div className="relative h-2 w-full rounded-full bg-muted overflow-hidden">
            <div
              className="relative h-full rounded-full bg-gradient-to-r from-primary via-violet-400 to-blue-400 transition-all duration-500"
              style={{ width: `${clampedProgress}%` }}
            >
              <span className="absolute right-0 top-1/2 h-3 w-3 -translate-y-1/2 rounded-full bg-blue-300/80 blur-[1px] animate-pulse" />
            </div>
          </div>
          <div className="grid grid-cols-3 gap-2 text-[11px] uppercase tracking-[0.12em] text-muted-foreground">
            <span className={stage === 'analyzing' ? 'text-foreground' : ''}>Analisando Conteúdo</span>
            <span className={stage === 'building' ? 'text-foreground text-center' : 'text-center'}>Construindo Estrutura Viral</span>
            <span className={stage === 'finalizing' ? 'text-foreground text-right' : 'text-right'}>Finalizando</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselGenerationLoading;
